import { Strings } from './strings';

export const getReviewsFields = {
  manager: [
    { label: Strings.reviews.behaviour, fieldName: 'behavior' },
    { label: Strings.reviews.taskPerformance, fieldName: 'taskPerformance' },
    { label: Strings.reviews.projectInvolvement, fieldName: 'projectInvolvement' },
    { label: Strings.reviews.communicationSkills, fieldName: 'communicationSkills' },
    { label: Strings.reviews.learningSkills, fieldName: 'learningSkills' },
    { label: Strings.reviews.disciplineManners, fieldName: 'disciplineManners' },
  ],
  teamMember: [
    { label: Strings.reviews.behaviour, fieldName: 'behavior' },
    { label: Strings.reviews.decisionMakingSkills, fieldName: 'decisionMakingSkills' },
    { label: Strings.reviews.leadershipSkills, fieldName: 'leadershipSkills' },
    { label: Strings.reviews.communicationSkills, fieldName: 'communicationSkills' },
    { label: Strings.reviews.fairTreatment, fieldName: 'fairTreatment' },
    { label: Strings.reviews.disciplineManners, fieldName: 'disciplineManners' },
  ],
};
